import Navbar from "../Components/Navbar"
import { Title, Group, Badge, Container, Text, Button} from "@mantine/core";











const Boompaydetails = () => {
    return (
        <>
            <Navbar />
            <Group justify='center' mt={'xl'}>
                <Badge
                    variant="outline"
                    size="lg"
                    p={'lg'}
                    mt={'xl'}
                    className='heading-pills'
                >
                    BOOM PAY
                </Badge>
            </Group>

            <Container mt={"xs"} size={"lg"} data-aos="fade-right">
                <Title ta={'center'} className='heading-as-text' size={'60'}>
                    Powering Digital Financial Services Across India
                </Title>

                <Group justify='center'>
                    <Text
                        c={'white'}
                        fw={'bold'}
                        className='heading-description'
                        mt={'md'}
                        ta={'center'}
                        maw={900}
                    >
                        Boom Pay is a next-generation fintech platform developed and managed by
                        GV Infotech. It provides secure and reliable digital financial services
                        including AEPS, Money Transfer, BBPS, Recharge, PAN Services, Payouts,
                        and other assisted banking solutions for retailers, distributors, and
                        business partners across India.
                    </Text>
                </Group>

                {/* Other Details */}

                <Group justify="center" mt="xl">
                    <Button
                        size="lg"
                        radius="xl"
                        component="a"
                        href="https://boompay.in"
                        target="_blank"
                    >
                        Visit Boom Pay Website
                    </Button>
                </Group>
            </Container>
        </>
    )
}

export default Boompaydetails;